var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H34V20.65Q34 21.8 33.425 22.75Q32.85 23.7 31.85 24.3L24.8 28.4L26.1 33.25H32.8L27.35 37.3L29.45 44L24 39.95L18.5 44L20.6 37.3L15.15 33.25H21.9L23.15 28.4L16.15 24.3Q15.15 23.7 14.575 22.75Q14 21.8 14 20.65ZM17 7V20.65Q17 21 17.225 21.3Q17.45 21.6 17.9 21.85L22.7 24.5V7ZM31 7H25.7V24.5L30.1 21.85Q30.55 21.6 30.775 21.3Q31 21 31 20.65ZM24.2 16.15ZM22.7 15.75Q22.7 15.75 22.7 15.75Q22.7 15.75 22.7 15.75ZM25.7 15.75Q25.7 15.75 25.7 15.75Q25.7 15.75 25.7 15.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillIcon);
export default __webpack_public_path__ + "static/media/skill-icon.e97bf16507be709b4b39865bb05f7ec5.svg";
export { ForwardRef as ReactComponent };